// ============================================================
// billEmailTemplate.ts — Send bill: the covering-email template's merge
// fields, client side (Admin › Billing preview + validation). Mirrors
// backend/src/lib/billEmail.ts (resolveMergeFields / unknownMergeFields);
// the server is authoritative — it resolves the real values at send time
// and refuses an unknown {Token} on save.
// ============================================================
const TOKEN = /\{([A-Za-z]+)\}/g

export const MERGE_FIELD_HELP: Record<string, string> = {
  ClientName: 'The client’s name, as on the bill',
  InvoiceNumber: 'The bill number',
  InvoiceDate: 'The date the bill was issued',
  DueDate: 'The date payment is due',
  Amount: 'The balance due',
  Matter: 'The matter name',
  FirmName: 'Your firm’s name',
  SenderName: 'The name of the person sending it',
}

export const unknownMergeFields = (text: string, known: readonly string[]): string[] => {
  const out: string[] = []
  for (const m of Array.from(text.matchAll(TOKEN))) if (!known.includes(m[1]) && !out.includes(m[1])) out.push(m[1])
  return out
}

export const resolveMergeFields = (text: string, values: Record<string, string>): string =>
  text.replace(TOKEN, (whole, name: string) => values[name] ?? whole)

// Example values for the preview (a real send uses the bill's own).
export const sampleMergeValues = (firmName: string, senderName: string, termsDays: number): Record<string, string> => {
  const long = (d: Date) => d.toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' })
  const today = new Date()
  return {
    ClientName: 'Mrs Jane Smith',
    InvoiceNumber: 'INV-2026-0047',
    InvoiceDate: long(today),
    DueDate: long(new Date(today.getTime() + termsDays * 86_400_000)),
    Amount: '£1,250.00',
    Matter: 'Smith v Jones (road traffic accident)',
    FirmName: firmName || 'Your Firm LLP',
    SenderName: senderName || 'Alex Taylor',
  }
}
